import { Injectable } from "@angular/core";
import { environment } from "../../../environments/environment";

declare global {
  interface Window {
    dataLayer?: Record<string, any>[];
    gtag?: (...args: any[]) => void;
  }
}

@Injectable({ providedIn: "root" })
export class GtmService {
  private _initialized: boolean = false;

  public get isEnabled(): boolean {
    return !!environment.gtm?.containerId;
  }

  public initialize(): void {
    if (this._initialized || !this.isEnabled) {
      return;
    }

    this._initialized = true;
    const containerId: string = environment.gtm!.containerId;

    window.dataLayer = window.dataLayer || [];
    window.gtag = function () {
      window.dataLayer!.push(arguments);
    };

    window.gtag("consent", "default", {
      "ad_storage": "denied",
      "ad_user_data": "denied",
      "ad_personalization": "denied",
      "analytics_storage": "denied"
    });

    window.dataLayer.push({
      "gtm.start": new Date().getTime(),
      "event": "gtm.js"
    });

    const script: HTMLScriptElement = document.createElement("script");
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtm.js?id=${ containerId }`;
    document.head.appendChild(script);

    const noscript: HTMLElement = document.createElement("noscript");
    const iframe: HTMLIFrameElement = document.createElement("iframe");
    iframe.src = `https://www.googletagmanager.com/ns.html?id=${ containerId }`;
    iframe.height = "0";
    iframe.width = "0";
    iframe.style.display = "none";
    iframe.style.visibility = "hidden";
    noscript.appendChild(iframe);
    document.body.insertBefore(noscript, document.body.firstChild);
  }

  public pushEvent(event: string, data?: Record<string, any>): void {
    if (!this.isEnabled) {
      return;
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, ...data });
  }

  public trackPageView(url: string, title?: string): void {
    this.pushEvent("page_view", {
      page_path: url,
      page_title: title
    });
  }
}
